import { GridType } from '@data-access/grid-views';
import { SubmissionGridTypes, SubmissionsGrid } from '../types';
import { InjectionToken } from '@angular/core';
import {
  DEFAULT_BASE_GRID_PROPS,
  DEFAULT_CHECKBOX_PROPS,
} from '@data-access/shared';

export const submissionListInitialState: SubmissionsGrid = {
  data: [],
  currentUrl: '',
  submissionListScope: null as SubmissionGridTypes | null,
  gridType: 'workspace-list' as GridType,
  views: [],
  isUpdatingSMEQC: false,
  ...DEFAULT_CHECKBOX_PROPS,
  ...DEFAULT_BASE_GRID_PROPS,
};

export const SUBMISSION_LIST_GRID_STATE = new InjectionToken<SubmissionsGrid>(
  'Submission List grid state',
  {
    factory: () => ({ ...submissionListInitialState }),
  },
);
